import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import AddressAutocomplete from '../../../../shared/AddressAutocomplete';
import FormSelect from '../../../../shared/FormSelect';
import FormTextField from '../../../../shared/FormTextField';
import { Address } from '../../../../types/generic';
import ItineraryAddressFields from './ItineraryAddressFields';
import { getAirportDisplayLabel, handleAirport } from './FlightForm';

const TransferForm = () => {
    const { control } = useFormContext();
    const {
        setValue,
        formState: { errors },
    } = useFormContext<any>();
    const pickupType = useWatch({
        control,
        name: 'itineraryItemInfo.pickupType',
    });
    const dropoffType = useWatch({
        control,
        name: 'itineraryItemInfo.dropoffType',
    });
    const pickupAirportError = (errors as any).itineraryItemInfo?.pickupAirport
        ?.name?.message;
    const dropoffAirportError = (errors as any).itineraryItemInfo
        ?.dropoffAirport?.name?.message;

    const pickUpAirport = useWatch({
        control,
        name: 'itineraryItemInfo.pickupAirport',
    });

    return (
        <Grid item container spacing={2}>
            <Grid item container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <FormTextField
                        name='itineraryItemInfo.provider'
                        control={control}
                        label='Provider'
                        placeholder='e.g. Uber'
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormTextField
                        name='itineraryItemInfo.vehicleType'
                        control={control}
                        label='Vehicle Type'
                        placeholder='e.g. Sedan'
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Typography variant='body3' sx={{ fontWeight: 600 }}>
                    Pickup from
                </Typography>
            </Grid>
            <Grid item xs={12}>
                {' '}
                <FormSelect
                    name='itineraryItemInfo.pickupType'
                    control={control}
                    label='Pickup type'
                    options={[
                        { value: 'airport', label: 'Airport' },
                        { value: 'address', label: 'Address' },
                    ]}
                />
            </Grid>
            <Grid container item spacing={2}>
                {pickupType === 'airport' ? (
                    <>
                        <Grid item xs={12} sm={6}>
                            <AddressAutocomplete
                                height='4px'
                                key='pickup-airport-autocomplete'
                                error={Boolean(pickupAirportError)}
                                helperText={pickupAirportError as string}
                                onChange={(address) =>
                                    handleAirport(
                                        address,
                                        'itineraryItemInfo.pickupAirport',
                                        setValue,
                                    )
                                }
                                initialInputValue={getAirportDisplayLabel(
                                    pickUpAirport,
                                )}
                                options={{
                                    fields: [
                                        'address_components',
                                        'geometry',
                                        'name',
                                        'formatted_address',
                                        'place_id',
                                    ],
                                    types: ['airport'],
                                    componentRestrictions: { country: 'au' },
                                }}
                                placeholder='Search airport...'
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormTextField
                                name='itineraryItemInfo.pickupAirport.terminal'
                                control={control}
                                label='Terminal'
                                placeholder='T1'
                            />
                        </Grid>
                    </>
                ) : (
                    <ItineraryAddressFields
                        name='itineraryItemInfo.pickupAddress'
                        autocompletePlaceholder='Search pickup address'
                    />
                )}
            </Grid>
            <Grid item xs={12}>
                <Typography variant='body3' sx={{ fontWeight: 600 }}>
                    Dropoff to
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <FormSelect
                    name='itineraryItemInfo.dropoffType'
                    control={control}
                    label='Dropoff type'
                    options={[
                        { value: 'airport', label: 'Airport' },
                        { value: 'address', label: 'Address' },
                    ]}
                />
            </Grid>
            <Grid container item spacing={2}>
                {dropoffType === 'airport' ? (
                    <>
                        <Grid item xs={12} sm={6}>
                            <AddressAutocomplete
                                height='4px'
                                key='dropoff-airport-autocomplete'
                                error={Boolean(dropoffAirportError)}
                                helperText={dropoffAirportError as string}
                                onChange={(address) =>
                                    handleAirport(
                                        address,
                                        'itineraryItemInfo.dropoffAirport',
                                        setValue,
                                    )
                                }
                                options={{
                                    fields: [
                                        'address_components',
                                        'geometry',
                                        'name',
                                        'formatted_address',
                                        'place_id',
                                    ],
                                    types: ['airport'],
                                    componentRestrictions: { country: 'au' },
                                }}
                                placeholder='Search airport...'
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormTextField
                                name='itineraryItemInfo.dropoffAirport.terminal'
                                control={control}
                                label='Terminal'
                                placeholder='T1'
                            />
                        </Grid>
                    </>
                ) : (
                    <ItineraryAddressFields
                        name='itineraryItemInfo.dropoffAddress'
                        autocompletePlaceholder='Search dropoff address'
                    />
                )}
            </Grid>
        </Grid>
    );
};

export default TransferForm;
